import { useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { Box } from "@mui/system";
import {
  setSelectedAffiliatedSystem,
  setSelectedIntegrationStatus,
  setSelectedLastRun,
  setSelectedReason,
  setSelectedWebsite,
  setSelectedStuckAt,
} from "../../../../../features/brandConfigurationReportSlice";
import FilterComponent from "../../../../ReusableFIlterComponent/FilterComponent";
import { capitalizeEachWords } from "../../../../../utils/helpers";

export default function BrandConfigReportTableFilterItems({
  clearSelectedBrandName,
}: any) {
  const dispatch = useDispatch();
  const {
    brandConfigurationReportList,
    selectedIntegrationStatus,
    selectedStuckAt,
    selectedReason,
    selectedAffiliatedSystem,
    selectedWebsite,
    selectedLastRun,
  } = useSelector((state: any) => state.brandConfigurationReport);

  const modifiedbrandConfiguration = brandConfigurationReportList.map(
    (item: any) => {
      if (
        item.integration_status === null ||
        item.integration_status === undefined ||
        item.integration_status === ""
      ) {
        return {
          ...item,
          integration_status: "Not Ready",
          additional_information: {
            ...item.additional_information,
            step: "Properties",
            reason: "Missing mandatory fields",
          },
        };
      }
      if (item.integration_status === "Ready") {
        return {
          ...item,
          additional_information: {
            ...item.additional_information,
            step: "Validations",
            reason: "Completed",
          },
        };
      }
      return {
        ...item,
      };
    },
  );

  //-- Extract unique values for filters(step) step === stuck_at
  const steps = modifiedbrandConfiguration
    .map((item: any) => {
      const step = item?.additional_information?.step; // Optional chaining
      return step ? { stuck_at: capitalizeEachWords(step) } : null; // Return null if undefined
    })
    .filter((item: any) => item !== null);

  const reasons = modifiedbrandConfiguration
    .map((item: any) => {
      const reason = item?.additional_information?.reason; // Optional chaining
      return reason ? { reason: reason } : null; // Return null if undefined
    })
    .filter((item: any) => item !== null);

  const lastRuns = modifiedbrandConfiguration
    .map((item: any) => {
      const last_run = item?.additional_information?.last_run; // Optional chaining
      return last_run ? { last_run: last_run } : null; // Return null if undefined
    })
    .filter((item: any) => item !== null);

  const [searchIntegrationStatus, setSearchIntegrationStatus] = useState("");
  const [searchStuckAt, setSearchStuckAt] = useState("");
  const [searchReason, setSearchReason] = useState("");
  const [searchAffiliatedSystem, setSearchAffiliatedSystem] = useState("");
  const [searchWebsite, setSearchWebsite] = useState("");

  const filterConfig = [
    {
      key: "IntegrationStatus",
      name: "Integration Status",
      label: "Select one or more Integration Status",
      searchTerm: searchIntegrationStatus,
      onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setSearchIntegrationStatus(e.target.value),
      selectedOption: selectedIntegrationStatus,
      filterName: "integration_status",
      data: modifiedbrandConfiguration,
      onSelectionChange: (updatedSelection: any) =>
        dispatch(setSelectedIntegrationStatus(updatedSelection)),
      count: selectedIntegrationStatus && selectedIntegrationStatus.length,
      colorSelected:
        selectedIntegrationStatus !== null &&
        selectedIntegrationStatus.length > 0
          ? "#9C27B0"
          : "#000000DE",
      multiSelect: true,
      showSearch: true,
    },
    {
      key: "StuckAt",
      name: "Stuck At",
      label: "Select one or more Stuck At",
      searchTerm: searchStuckAt,
      onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setSearchStuckAt(e.target.value),
      selectedOption: selectedStuckAt,
      filterName: "stuck_at",
      data: steps,
      onSelectionChange: (updatedSelection: any) =>
        dispatch(setSelectedStuckAt(updatedSelection)),
      count: selectedStuckAt && selectedStuckAt.length,
      colorSelected:
        selectedStuckAt !== null && selectedStuckAt.length > 0
          ? "#9C27B0"
          : "#000000DE",
      multiSelect: true,
      showSearch: true,
    },
    {
      key: "Reason",
      name: "Reason",
      label: "Select one or more Reason",
      searchTerm: searchReason,
      onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setSearchReason(e.target.value),
      selectedOption: selectedReason,
      filterName: "reason",
      data: reasons,
      onSelectionChange: (updatedSelection: any) =>
        dispatch(setSelectedReason(updatedSelection)),
      count: selectedReason && selectedReason.length,
      colorSelected:
        selectedReason !== null && selectedReason.length > 0
          ? "#9C27B0"
          : "#000000DE",
      multiSelect: true,
      showSearch: true,
    },
    {
      key: "AffiliatedSystem",
      name: "Affiliated System",
      label: "Select one or more Affiliated System",
      searchTerm: searchAffiliatedSystem,
      onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setSearchAffiliatedSystem(e.target.value),
      selectedOption: selectedAffiliatedSystem,
      filterName: "backend_interface_name",
      data: modifiedbrandConfiguration,
      onSelectionChange: (updatedSelection: any) =>
        dispatch(setSelectedAffiliatedSystem(updatedSelection)),
      count: selectedAffiliatedSystem && selectedAffiliatedSystem.length,
      colorSelected:
        selectedAffiliatedSystem !== null && selectedAffiliatedSystem.length > 0
          ? "#9C27B0"
          : "#000000DE",
      multiSelect: true,
      showSearch: true,
    },
    {
      key: "Websites",
      name: "Website",
      label: "Select one or more Website",
      searchTerm: searchWebsite,
      onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setSearchWebsite(e.target.value),
      selectedOption: selectedWebsite,
      filterName: "ui_site_name",
      data: modifiedbrandConfiguration,
      onSelectionChange: (updatedSelection: any) =>
        dispatch(setSelectedWebsite(updatedSelection)),
      count: selectedWebsite && selectedWebsite.length,
      colorSelected:
        selectedWebsite !== null && selectedWebsite.length > 0
          ? "#9C27B0"
          : "#000000DE",
      multiSelect: true,
      showSearch: true,
    },
    {
      key: "Last Run",
      label: "Select Date",
      searchTerm: "",
      selectedOption: selectedLastRun,
      filterName: "last_run",
      data: lastRuns,
      onSelectionChange: (updatedSelection: any) =>
        dispatch(setSelectedLastRun(updatedSelection)),
      count: selectedLastRun && selectedLastRun.length - 1,
      colorSelected:
        selectedLastRun !== null && selectedLastRun.length > 0
          ? "#9C27B0"
          : "#000000DE",
      multiSelect: true,
      showSearch: false,
      isDateRangeFilter: true,
    },
  ];

  const clearFilters = () => {
    dispatch(setSelectedIntegrationStatus([]));
    dispatch(setSelectedStuckAt([]));
    dispatch(setSelectedReason([]));
    dispatch(setSelectedAffiliatedSystem([]));
    dispatch(setSelectedWebsite([]));
    dispatch(setSelectedLastRun([]));

    clearSelectedBrandName("");
    setSearchIntegrationStatus("");
    setSearchStuckAt("");
    setSearchReason("");
    setSearchAffiliatedSystem("");
    setSearchWebsite("");
  };

  return (
    <Box data-tracker="621" sx={{ position: "relative" }}>
      <FilterComponent
        filterConfig={filterConfig}
        clearFilters={clearFilters}
      />
    </Box>
  );
}
